import { initializeApp, type FirebaseApp } from 'firebase/app';
import { browserLocalPersistence, getAuth, setPersistence, type Auth } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  type Firestore,
} from 'firebase/firestore';
import { webConfig } from '@/config/env';

/**
 * אתחול Firebase בצד הלקוח.
 * - Auth: התחברות מנהלים באימייל וסיסמה, נשמרת במכשיר.
 * - Firestore: קריאה בלבד (כללי האבטחה חוסמים כתיבה מהלקוח), עם מטמון מקומי
 *   כדי שהאפליקציה תציג נתונים אחרונים גם בקליטה חלשה.
 */

let app: FirebaseApp | null = null;
let auth: Auth | null = null;
let db: Firestore | null = null;

export function getFirebase(): { app: FirebaseApp; auth: Auth; db: Firestore } {
  if (!webConfig.ok) throw new Error('Firebase config missing');
  if (!app) {
    app = initializeApp(webConfig.config.firebase);
    auth = getAuth(app);
    auth.languageCode = 'he';
    void setPersistence(auth, browserLocalPersistence);
    db = initializeFirestore(app, {
      localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
    });
  }
  return { app, auth: auth!, db: db! };
}
